import { render, staticRenderFns } from "./EditNekretnine.vue?vue&type=template&id=a6d30fa4&scoped=true&"
import script from "./EditNekretnine.vue?vue&type=script&lang=js&"
export * from "./EditNekretnine.vue?vue&type=script&lang=js&"
import style0 from "./EditNekretnine.vue?vue&type=style&index=0&id=a6d30fa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d30fa4",
  null
  
)

export default component.exports